import { Component } from '@angular/core';

/**
 * The Contact Us page (owner 2026-10-12): the nav popover's form (app-contact-form) in the popover's card, under the
 * Apps & Plugins hero band. The page stays for the bottom nav, a new tab and the links to it.
 */
@Component( {
  selector: 'app-contact-us-page',
  templateUrl: './contact-us-page.component.html',
  styleUrls: [
    '../tool-pages/tools-page/tools-page.component.scss',
    '../plugin-pages/plugins-page/plugins-page.component.scss',
    './contact-us-page.component.scss',
  ],
} )
export class ContactUsPageComponent {
}
